module.exports = __webpack_public_path__ + "img/LoginBackground.345f33f8.png";